import './NavTop.scss';

import React from 'react';
import Nav from '../nav/Nav';
import logo from 'images/motor-gruppen-logo.svg';
import config from './../../../../../config/config';

class NavTopComponent extends React.Component {
  componentDidMount() {
    if (!this.props.authService.authenticated()) {
      this.props.login();
    }
  }

  componentDidUpdate() {
    if (!this.props.authService.authenticated()) {
      this.props.login();
    }
  }

  render() {
    // Only show Nav if authenticated
    let navUI = false;
    let profileUI = false;
    const environment = (config.contentful.environment || 'master');
    const environmentName = environment === 'master' ? 'Prod' : environment;

    if (this.props.authService.authenticated()) {
      navUI = (<Nav authService={this.props.authService}/>);
      profileUI = (<ul className="nav navbar-top-links navbar-right">
        <li className="dropdown">
          <a className="dropdown-toggle" data-toggle="dropdown" href="#">
            <i className="fa fa-user fa-fw"></i> {this.props.userProfile.name} <i className="fa fa-caret-down"></i>
          </a>
          <ul className="dropdown-menu dropdown-user">
            <li>
              <a style={{cursor: 'pointer'}} onClick={() => this.props.logout() && window.location.reload()}><i className="fa fa-sign-out fa-fw"></i> Logg ut</a>
            </li>
          </ul>
        </li>
      </ul>);
    }

    return (
      <nav className="navbar navbar-default navbar-static-top" role="navigation">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a href="/"><img className="navbar-brand" src={logo} title="logo" alt="logo" height="50" /></a>
        </div>
        <div className="navbar-brand">{environmentName}</div>
        {profileUI}
        {navUI}
      </nav>

    );
  }
}

export default NavTopComponent;
